import React, {useEffect, useState} from "react";
import Modal from "react-modal";
import "../Components/ComponentCss/EditModal.css";
import axios from "axios";
import config from "../ip.json";
import Swal from "sweetalert2";

const EditModal = ({
                       isOpen,
                       closeModal,
                       companyName,
                       businessNumber,
                       representative,
                       phoneNumber,
                       room,
                       entryDate,
                       deposit,
                       isCorporate,
                       depositByRoom,
                   }) => {

    const [formValues, setFormValues] = useState({
        companyName: "",
        businessNumber: "",
        representative: "",
        phoneNumber: "",
        entryDate: "",
        deposit: 0,
        isCorporate: false,
        depositByRoom: [],
    });

    const [initialValues, setInitialValues] = useState({}); // 초기 값 저장


    useEffect(() => {
        const initialFormValues = {
            companyName: companyName || "",
            businessNumber: businessNumber || "",
            representative: representative || "",
            phoneNumber: phoneNumber || "",
            entryDate: entryDate ? new Date(entryDate).toISOString().split("T")[0] : "",
            deposit: deposit || 0,
            isCorporate: isCorporate || false, // 초기 값을 정확히 설정
            depositByRoom: depositByRoom || [],
        };

        setFormValues(initialFormValues);
        setInitialValues(initialFormValues); // 초기 값을 저장

    }, [companyName, businessNumber, representative, phoneNumber, entryDate, deposit, isCorporate, depositByRoom]);
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;

        if (name === "isCorporate") {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: checked,
                companyName: checked
                    ? `(주) ${prevValues.companyName.replace(/^$begin:math:text$주$end:math:text$ /, "")}`
                    : prevValues.companyName.replace(/^\(주\) /, ""),
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: type === "checkbox" ? checked : value,
            }));
        }

    };

    const handleSave = async () => {
        // 변경 전과 변경 후를 명시적으로 다루는 방식
        const messages = [];
        // 각 필드별 비교
        if (initialValues.companyName !== formValues.companyName) {
            messages.push(formValues.companyName);
        } else {
            messages.push(null);
        }

// businessNumber 필드 처리
        if (initialValues.businessNumber !== formValues.businessNumber) {
            messages.push(formValues.businessNumber);
        } else {
            messages.push(null);
        }

// representative 필드 처리
        if (initialValues.representative !== formValues.representative) {
            messages.push(formValues.representative);
        } else {
            messages.push(null);
        }

// phoneNumber 필드 처리
        if (initialValues.phoneNumber !== formValues.phoneNumber) {
            messages.push(formValues.phoneNumber);
        } else {
            messages.push(null);
        }

// entryDate 필드 처리
        if (initialValues.entryDate !== formValues.entryDate) {
            messages.push(formValues.entryDate);
        } else {
            messages.push(null);
        }


// isCorporate 필드 처리
        if (initialValues.isCorporate !== formValues.isCorporate) {
            messages.push(formValues.isCorporate);
        } else {
            messages.push(null);
        }

// depositByRoom 필드 처리
        if (JSON.stringify(initialValues.depositByRoom) !== JSON.stringify(formValues.depositByRoom)) {
            // depositByRoom 안의 요소들이 숫자 타입으로 변환된 값을 사용
            const depositByRoomAsNumbers = formValues.depositByRoom.map(item => Number(item));

            // 변환된 숫자 배열을 메시지에 추가
            messages.push(depositByRoomAsNumbers);
            // alert(depositByRoomAsNumbers+"sdfssdfsddf");

            // 테스트용 알림: 변환된 첫 번째 값이 숫자임을 확인
            // alert(depositByRoomAsNumbers[0] + " sdfdsfsd");
            // alert(depositByRoomAsNumbers[1] + " sdfdsfsd");
            // alert(depositByRoomAsNumbers[2] + " sdfdsfsd");
        } else {
            messages.push(null);
        }



        const jwtToken = sessionStorage.getItem("Authorization");

        try {
            const response = await axios.post(
                config.url + "/v2/company/update",
                {
                    company: companyName,
                    // newCompany:null,
                    // certificate: null,
                    // boss: "황봉식티비",
                    // phone: null,
                    // regDate: null,
                    // isCorp: null,
                    // depositByRooms: [],
                    // rooms:[]

                    newCompany: messages[0] ,
                    certificate: messages[1],
                    boss: messages[2] ,
                    phone: messages[3] ,
                    regDate: messages[4] , // 필요한 경우 주석 제거
                    isCorp: messages[5] ,
                    depositByRooms: messages[6] === null ? [] : messages[6],
                    rooms: messages[6] === null ? [] : room,
                },
                {
                    headers: {
                        Authorization: jwtToken,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );
            저장성공()

        } catch (error) {
            console.error("Error fetching data:", error);
            저장실패()
        }


        closeModal();
    };

    const 저장성공 = () => {
        Swal.fire({
            title: "저장되었습니다!",
            icon: "success"
        });
    };

    const 저장실패 = () => {
        Swal.fire({
            title: "저장에 실패하였습니다.",
            icon: "error"
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="기업 정보 수정"
            className="exit-modal"
            overlayClassName="exit-modal-overlay"
        >
            <div className="edit-modal-content">
                <h2>기업 정보 수정</h2>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">법인기업 여부</div>
                    <div>
                        <input
                            type="checkbox"
                            id="is-corporate"
                            name="isCorporate"
                            checked={formValues.isCorporate} // formValues.isCorporate에 따라 체크 상태 설정
                            onChange={handleChange}
                        />
                        <label htmlFor="is-corporate">법인기업</label>
                    </div>
                </div>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">기업명</div>
                    <input
                        className="edit-modal-company-name-text"
                        name="companyName"
                        value={formValues.companyName}
                        onChange={handleChange}
                    />
                </div>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">사업자번호 or 법인번호</div>
                    <input
                        className="edit-modal-company-name-text"
                        name="businessNumber"
                        value={formValues.businessNumber}
                        onChange={handleChange}
                    />
                </div>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">대표자</div>
                    <input
                        className="edit-modal-company-name-text"
                        name="representative"
                        value={formValues.representative}
                        onChange={handleChange}
                    />
                </div>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">전화번호</div>
                    <input
                        className="edit-modal-company-name-text"
                        name="phoneNumber"
                        value={formValues.phoneNumber}
                        onChange={handleChange}
                    />
                </div>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">입주일자</div>
                    <input
                        className="edit-modal-company-name-text"
                        name="entryDate"
                        type="date"
                        value={formValues.entryDate}
                        onChange={handleChange}
                    />
                </div>

                <div className="edit-modal-print-component">
                    <div className="edit-modal-company-name">호실별 보증금</div>
                    <div className="edit-modal-room-list">
                        {room.map((roomNumber, index) => (
                            <div key={index} className="edit-modal-room-item">
                                <span>{roomNumber}호: </span>
                                <input
                                    type="number"
                                    className="edit-modal-company-name-text"
                                    value={formValues.depositByRoom[index] || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormValues((prevValues) => {
                                            const updatedDepositByRoom = [...prevValues.depositByRoom]; // 새로운 배열을 생성
                                            updatedDepositByRoom[index] = value; // 해당 인덱스 값만 업데이트
                                            return {
                                                ...prevValues,
                                                depositByRoom: updatedDepositByRoom, // 새로운 배열로 업데이트
                                            };
                                        });
                                    }}
                                    placeholder="보증금 입력"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="exit-modal-buttons">
                    <button onClick={closeModal}>취소</button>
                    <button onClick={handleSave}>저장</button>
                </div>
            </div>
        </Modal>
    );
};

export default EditModal;